import NamedDto from 'modules/base/dto/NamedDto';

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key);

const normalizeLegacyComponentValues = (value, minValue, maxValue) => {
	if (!value || typeof value !== 'object' || Array.isArray(value)) return { value, minValue, maxValue };

	const normalizedValue = {};
	const nestedMinValue = {};
	const nestedMaxValue = {};
	let hasLegacyEntries = false;

	Object.keys(value).forEach(key => {
		const entry = value[key];
		const isLegacyEntry = entry && typeof entry === 'object' && !Array.isArray(entry)
			&& (hasOwn(entry, 'value') || hasOwn(entry, 'min_value') || hasOwn(entry, 'max_value')
				|| hasOwn(entry, 'minValue') || hasOwn(entry, 'maxValue'));

		if (!isLegacyEntry) {
			normalizedValue[key] = entry;
			return;
		}

		hasLegacyEntries = true;
		normalizedValue[key] = entry.value;

		if (hasOwn(entry, 'minValue') || hasOwn(entry, 'min_value'))
			nestedMinValue[key] = hasOwn(entry, 'minValue') ? entry.minValue : entry.min_value;
		if (hasOwn(entry, 'maxValue') || hasOwn(entry, 'max_value'))
			nestedMaxValue[key] = hasOwn(entry, 'maxValue') ? entry.maxValue : entry.max_value;
	});

	if (!hasLegacyEntries) return { value, minValue, maxValue };

	return {
		value: normalizedValue,
		minValue: minValue ?? (Object.keys(nestedMinValue).length > 0 ? nestedMinValue : null),
		maxValue: maxValue ?? (Object.keys(nestedMaxValue).length > 0 ? nestedMaxValue : null)
	};
};

export class AnnModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _AnnModelInputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} uom
	 * @property {string} value
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AnnModelInputAttributeEditDtoProps} AnnModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {AnnModelInputAttributeEditDtoProps} props
	 * @returns {AnnModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		const values = normalizeLegacyComponentValues(props.value, props.minValue, props.maxValue);
		this.type = props.type;
		this.uom = props.uom;
		this.value = values.value;
		this.minValue = values.minValue;
		this.maxValue = values.maxValue;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default AnnModelInputAttributeEditDto;
